import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getTripsReport } from '../../services/Reports';

function useGetTripsReport(fleetId: string, query: string): UseQueryResult<any> {
  return useQuery(
    ['report-trips', fleetId, query],
    async (): Promise<any> => getTripsReport(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: false,
      refetchInterval: false,
    },
  );
}

export default useGetTripsReport;
